import type {
  BookingStatus,
  OperationItem,
} from '@travel-planner/shared/schemas/operations';
import { bookingStatusValues } from '@travel-planner/shared/schemas/operations';

// Booking status options (legacy types/booking-status): label + dot colour
// mirror the legacy BookingStatusDot menu.
export type BookingStatusOption = {
  value: BookingStatus;
  label: string;
  color: string;
};

const BOOKING_STATUS_META: Record<
  BookingStatus,
  { label: string; color: string }
> = {
  NotRequested: { label: 'Not requested', color: '#9CA3AF' },
  Requested: { label: 'Requested', color: '#FACC15' },
  Rejected: { label: 'Rejected', color: '#DC2626' },
  Confirmed: { label: 'Confirmed', color: '#16A34A' },
  Cancelled: { label: 'Cancelled', color: '#FCA5A5' },
};

export const BOOKING_STATUS_OPTIONS: readonly BookingStatusOption[] =
  bookingStatusValues.map((value) => ({
    value,
    label: BOOKING_STATUS_META[value].label,
    color: BOOKING_STATUS_META[value].color,
  }));

export const bookingStatusLabel = (status: BookingStatus): string =>
  BOOKING_STATUS_META[status].label;

export const bookingStatusColor = (status: BookingStatus): string =>
  BOOKING_STATUS_META[status].color;

// Legacy supportsBookingStatus — only Dining/Activity items carry it.
export const supportsBookingStatus = (
  item: Pick<OperationItem, 'contentCategory'>
): boolean =>
  item.contentCategory === 'Dining' || item.contentCategory === 'Activity';
